<template>
	<div style="overflow: auto;">
		<div class="clearfix"></div>
		<div style="margin: 0;padding: 0;padding-bottom: 30px;display: table;border-collapse: separate;border-spacing: 10px;" v-if="generics && generics.length > 0" :style="{'width': (size == 'big' ? (genericsLength * 315) : (genericsLength * 188)) + 'px'}">
			<div v-for="(generic, index) in generics" :key="'generic_'+index" class="card ml-1 mr-1 generic-card" style="margin-right: 15px;display: table-cell;margin-bottom:15px;" :style="{'width': size == 'big' ? '300px' : '173px'}" >
				<div class="card-img" :style="{'height': size == 'big' ? '156px' : '90px'}" style="border-bottom: 1px solid #eee">
					<template v-if="generic.image_url">
						<div :style="{'height': size == 'big' ? '156px' : '90px','background-image': 'url(\''+ generic.image_url +'\')' }" style="width: 100%; height: 90px;background-size: cover;background-position: center;background-repeat: no-repeat;"></div>
						<!-- <img class="card-img-top" :src="generic.image_url"  > -->
					</template>
					<template v-else>
						<div :style="{'height': size == 'big' ? '156px' : '90px','background-image': 'url(\'/static/img/assets/generic/generic_default_thumbnail.png\')' }" style="width: 100%; height: 90px;background-size: cover;background-position: center;background-repeat: no-repeat;"></div>
					</template>
				</div>
				
				<div class="card-body" style="padding: 0px 8px;height: 110px">
					<h4 class="card-title" style="font-weight: 600" :style="{'font-size': size == 'big' ? 'inherit' : '12px'}">
						<template v-if="generic.title">
							<specialtext :text="generic.title" :truncate="40"></specialtext>
						</template>
						<template v-else>
							No Text
						</template>
					</h4>

					<p class="card-text" :style="{'font-size': size == 'big' ? 'inherit' : '12px'}">
						<template v-if="generic.subtitle">
							<specialtext :text="generic.subtitle" :truncate="90"></specialtext>
						</template>
						<template v-else>
							No Text
						</template>
					</p>
				</div>
				
				<div class="card-footer">
					<ul class="list-group list-group-flush" style="margin-bottom: 0px;">
						<template v-if="generic.buttons.length > 0">
							<li class="list-group-item" style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center" v-for="(button,bindex) in generic.buttons" :key="bindex">
								<span>{{ button.title }}</span>
							</li>
						</template>
						<template v-else>
							<li class="list-group-item" style="border:none; border-top:1px solid #eee;border-radius: 0px;text-align: center"><span>-</span></li>
						</template>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import specialtext from '@/components/elements/specialtext'
    export default {
		props: {
			value: [Object,String,Array],
			size: {
				type: String,
				default: 'big'
			}
		},
		components: {
			specialtext
		},
		computed: {
			genericsLength: function(){
				var count = 0
				// $.each(this.generics,function(index, val){
				// 	if (val.enable) {
				// 		count++
				// 	}
				// })
				return this.generics.length
			}
		},
		data: function(){
			return {
				generics: this.value
			}
		},
		watch: {
			value: function(){
				this.generics = this.value
			}
		}
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/GenericViewer.vue